import styled from "styled-components";
import { theme } from "../../styles/theme";

export const DropArea = styled.div`
    width: 100%;
    box-sizing: border-box;
    border: 1.5px dashed ${theme.colors.gray.Cinza_9};
    border-radius: 14px;
    padding: 28px 20px;
    text-align: center;
    cursor: pointer;
    background: ${theme.colors.gray.Cinza_13};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    transition: border-color .15s, background .15s;

    ${props => props.$active && `
        border-color: ${theme.colors.green.Verde_AgroReceita};
        background: ${theme.colors.green.Fundo};
    `}

    &:hover {
        border-color: ${theme.colors.green.Verde_AgroReceita};
        background: ${theme.colors.green.Fundo};
    }
`;

export const DropIcon = styled.span`
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: ${theme.colors.gray.Cinza_12};
    color: ${theme.colors.gray.Cinza_6};
    display: grid;
    place-items: center;
`;

export const DropTitle = styled.b`
    font-size: 14px;
    font-family: ${theme.typography.fontFamily.primary};
    color: ${theme.colors.gray.Cinza_2};

    span {
        color: ${theme.colors.green.Verde_AgroReceita};
    }
`;

export const DropDesc = styled.p`
    margin: 0;
    font-size: 12px;
    line-height: 1.5;
    color: ${theme.colors.gray.Cinza_6};
    max-width: 420px;
`;

export const DropCaption = styled.small`
    font-size: 12px;
    color: ${theme.colors.gray.Cinza_7};
`;

export const FileCard = styled.div`
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 14px;
    border: 1px solid ${theme.colors.gray.Cinza_11};
    border-radius: 14px;
    padding: 14px 16px;
    background: ${theme.colors.white.Branco};
`;

export const FileBadge = styled.span`
    background: ${theme.colors.green.Fundo};
    color: ${theme.colors.green.Bandeira};
    font-size: 10px;
    font-weight: 800;
    letter-spacing: .05em;
    border-radius: 6px;
    padding: 8px 9px;
    white-space: nowrap;
`;

export const FileInfo = styled.div`
    flex: 1;
    min-width: 0;
    text-align: left;

    b {
        display: block;
        font-size: 13px;
        font-weight: 700;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: ${theme.colors.gray.Cinza_2};
    }

    small {
        font-size: 12px;
        color: ${theme.colors.gray.Cinza_7};
    }
`;

export const RemoveButton = styled.button`
    width: 30px;
    height: 30px;
    border-radius: 50%;

    border: none;
    background: none;
    color: ${theme.colors.gray.Cinza_6};
    display: grid;
    place-items: center;
    cursor: pointer;
    flex-shrink: 0;
`;
